import { SUPPORTED_LANGUAGES, type SupportedLanguage } from "./index";

export function isSupportedLocale(value: string | undefined | null): value is SupportedLanguage {
  if (!value) return false;
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(value);
}

/** Pick best default locale: localStorage > navigator > 'en'. */
export function pickDefaultLocale(): SupportedLanguage {
  if (typeof window !== "undefined") {
    const stored = window.localStorage.getItem("bp.language");
    if (isSupportedLocale(stored)) return stored;
    const nav = (window.navigator?.language || "en").slice(0, 2).toLowerCase();
    if (isSupportedLocale(nav)) return nav;
  }
  return "fr";
}

/** Strip a leading /xx locale segment from a path; return null if none. */
export function stripLocaleFromPath(pathname: string): { locale: SupportedLanguage | null; rest: string } {
  const m = pathname.match(/^\/([a-z]{2})(?=\/|$)(.*)$/);
  if (m && isSupportedLocale(m[1])) {
    const rest = m[2] || "/";
    return { locale: m[1], rest: rest.startsWith("/") ? rest : `/${rest}` };
  }
  return { locale: null, rest: pathname };
}

/** Build a localized path: prepend /{locale} to a leading-slash path. */
export function withLocale(locale: SupportedLanguage, path: string): string {
  if (!path.startsWith("/")) path = `/${path}`;
  // If path already starts with a locale, replace it
  const stripped = stripLocaleFromPath(path);
  return `/${locale}${stripped.rest === "/" ? "" : stripped.rest}` || `/${locale}`;
}
